import { render, staticRenderFns } from "./Inscribed.vue?vue&type=template&id=4ab5a537&"
import script from "./Inscribed.vue?vue&type=script&lang=js&"
export * from "./Inscribed.vue?vue&type=script&lang=js&"
import style0 from "./Inscribed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports